// import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import Accordion from 'components/total-eclipse/Accordion'
import Button from 'components/total-eclipse/Button'
import TESpacer from 'components/total-eclipse/Spacer'
import Header from 'components/total-eclipse/Header'
import Subheader from 'components/total-eclipse/Subheader'

import Diameter from './diameter.svg'
import Dial from './dial.svg'
import Material from './material.svg'
import Movement from './movement.svg'

import { Root, Main, Spacer } from './Footer.style'

const Footer = () => {
  return (
    <Root>
      <Main>
        <Fade>
          <Header className="text-center">Specification and Availability</Header>
          <Spacer />
          <Spacer />
          <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-12 justify-items-center text-center">
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Diameter className="w-full h-auto" />
              </div>
              <Subheader>Diameter</Subheader>
              <p className="block mt-2 uppercase text-sm">38MM</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Dial className="w-full h-auto" />
              </div>
              <Subheader>Case</Subheader>
              <p className="block mt-2 uppercase text-sm">Steel</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Material className="w-full h-auto" />
              </div>
              <Subheader>Material</Subheader>
              <p className="block mt-2 uppercase text-sm">Vantablack®</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Movement className="w-full h-auto animate-spin-slow" />
              </div>
              <Subheader>Movement</Subheader>
              <p className="block mt-2 uppercase text-sm">HMC 327</p>
            </div>
          </div>
          <Spacer />
          <div className="w-full grid sm:grid-cols-2 gap-x-10 gap-y-8">
            <div>
              <Subheader>Steel Edition</Subheader>
              <p className="block mt-5 text-sm">
                Reference 1327-1200, steel model, Vantablack® dial, black calf leather, limited edition of 28 pieces.
              </p>
            </div>
            <div>
              <Subheader>Red Gold Edition</Subheader>
              <p className="block mt-5 text-sm">
                Reference 1327-1201, steel and red gold model, Vantablack® dial, black calf leather, limited edition of
                28 pieces.
              </p>
            </div>
          </div>
          <Spacer />
          <Accordion
            items={[
              {
                header: 'Case',
                body: (
                  <ul>
                    <li>Steel or steel with 5N red gold inner bezel</li>
                    <li>Diameter: 38.0 mm</li>
                    <li>Height: 9.9 mm </li>
                    <li>Sapphire crystal </li>
                    <li>See-through case back with sapphire crystal</li>
                    <li>Crown adorned with an “M”</li>
                  </ul>
                ),
              },
              {
                header: 'Dial',
                body: (
                  <ul>
                    <li>Vantablack® with 12 indices</li>
                    <li>Breguet-shaped hour and minute hands in steel or in 5N red gold</li>
                    <li>Small seconds hand in steel or in 5N red gold</li>
                  </ul>
                ),
              },
              {
                header: 'Movement',
                body: (
                  <ul>
                    <li>Hand-wound HMC 327 Manufacture calibre</li>
                    <li>Diameter: 32.0 mm or 14 ¼ lignes/height: 4.5 mm</li>
                    <li>Frequency: 18,000 Vib/h</li>
                    <li>29 jewels</li>
                    <li>Power reserve: minimum of 3 daysHacking seconds</li>
                    <li>Moser teeth for all wheels and pinions</li>
                    <li>Movement and components hand-finished and decorated</li>
                    <li>Moser balance wheel and original Straumann® Hairspring</li>
                  </ul>
                ),
              },
              {
                header: 'Functions',
                body: (
                  <ul>
                    <li>Hours and minutes</li>
                    <li>Small seconds at 6 o’clock</li>
                    <li>Power reserve indication at the back</li>
                  </ul>
                ),
              },
              {
                header: 'Strap',
                body: (
                  <ul>
                    <li>Hand-stitched black calf leather, two-tone effect with two different textures</li>
                    <li>Steel pin buckle, engraved with the Moser logo</li>
                  </ul>
                ),
              },
            ]}
          />
          <Spacer />
          <Spacer />
          <Header className="text-center">Price</Header>
          <Spacer />
          <div className="w-full grid sm:grid-cols-2 gap-x-10 gap-y-8">
            <div>
              <Subheader>Steel Edition</Subheader>
              <p className="block mt-5 text-sm">
                USD 25,900
              </p>
            </div>
            <div>
              <Subheader>Red Gold Edition</Subheader>
              <p className="block mt-5 text-sm">
                USD 25,900
              </p>
            </div>
          </div>
          <Spacer />
          <Spacer />
          <Header className="text-center">Viewing And Appointments</Header>
          <Spacer />
          <p className="text-center">To see the Total Eclipse in the metal from Jan 19th - 27th, please visit:</p>
          <Spacer />
          <div className="w-full grid sm:grid-cols-2 gap-x-10 gap-y-8 justify-items-center">
            <div>
              <p className="text-center text-sm whitespace-nowrap font-bold">
                The Armoury Tribeca
                <br />
                168 Duane Street
                <br />
                New York, United States
              </p>
            </div>
            <div>
              <p className="text-center text-sm whitespace-nowrap font-bold">
                The Armoury Landmark Central
                <br />
                B47 Landmark Central 15 Queen’s Road
                <br />
                Central Central, Hong Kong
              </p>
            </div>
          </div>
          <Spacer />
          <Spacer />
          <Header className="text-center">How To Purchase</Header>
          <Spacer />
          <p>
            In order to serve interested parties fairly, The Armoury will be selling its stock of the Total Eclipse by
            lottery. To participate in the lottery, please visit our online store to place a refundable deposit for the
            version you are interested in and you will be entered into the lottery.
          </p>
          <p>
            We believe that the purchase of a watch should be considered carefully and without excessive pressure. The
            window for purchasing a lottery ticket ends at 11:59pm US EST on the 26th of January. As long as you have
            paid your deposit through our online store, you are eligible for the lottery.
          </p>
          <p>
            Winners of the lottery will be contacted on the 27th January, 2022 and the remaining balance will be due
            upon delivery. Entrants who did not win the lottery will have their deposits promptly refunded.
          </p>
          <Spacer />
          <div className="text-center">
            <Button
                 role="button"
//               as="a"
//               href="https://thearmoury.com/products/total-eclipse-lottery-deposit"
//               target="_blank"
//               rel="noreferer"
            >
              Sold Out!
            </Button>
          </div>
          <Spacer />
          <p className="text-center">
            For more information please contact <a href="mailto:nyc@thearmoury.com">nyc@thearmoury.com</a>
          </p>
        </Fade>
      </Main>
      <TESpacer />
    </Root>
  )
}

Footer.propTypes = {}

Footer.defaultProps = {}

export default Footer
